import React from 'react'
import { ModuleSlider } from 'containers/ModuleSlider/ModuleSlider'
import { WelcomeBanner } from 'containers/WelcomeBanner/WelcomeBanner'
import { Flex, FlexCell } from 'components'
import { LayoutList } from 'containers/Layout'
import { useSelector } from 'react-redux'
import { selectClientId } from 'services/slices/auth'
import { Home as HomeV3 } from './HomeV3'

export const Home: React.FC<React.PropsWithChildren<unknown>> = () => {
  // if (!import.meta.env.NODE_ENV || import.meta.env.NODE_ENV === 'development') {
  //   return <>Visible in development mode only 🚀</>
  // }

  const clientId = useSelector(selectClientId)

  if (
    clientId &&
    window.widgetConfig?.clients &&
    !!window.widgetConfig?.clients?.find((c) => c.clientId === clientId)
  ) {
    return <HomeV3 />
  }

  return (
    <LayoutList>
      <Flex directionColumn="zero" fullHeight gap={2}>
        <FlexCell>
          <WelcomeBanner />
        </FlexCell>
        <FlexCell>
          <ModuleSlider />
        </FlexCell>
      </Flex>
    </LayoutList>
  )
}
